.header {
  display: flex;
  align-items: center;
  max-width: calc(var(--column) + 2 * var(--gutter));
  margin: 0 auto;
  padding: 12px var(--gutter);
}

.card {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 16px var(--gutter) 40px;
}

@media (min-width: 720px) {
  .card {
    max-width: 520px;
    margin: 40px auto 0;
    padding: 32px 40px 40px;
    background: var(--surface);
    border: var(--outline);
    border-radius: var(--radius-card);
    box-shadow: var(--shadow-dialog);
  }
}
